import { toI18n } from 'util/i18n';

export const TIP_MANAGER_SUBSCRIPTION_TYPE = 'Tip Manager';
export const TASK_MANAGER_SUBSCRIPTION_TYPE = 'Task Manager';

export const CANCEL_ADDONS_SLICE = 'cancelAddons';

export const I18N_PREFIX: string = 'settings.pages.billing.cancel_addons_page';

export const RADIO_OPTIONS: { name: string; label: any }[] = [
  {
    name: 'not_enough_value_for_price',
    label: toI18n(`${I18N_PREFIX}.tell_us_why.radio.not_enough_value`),
  },
  {
    name: 'no_longer_needed',
    label: toI18n(`${I18N_PREFIX}.tell_us_why.radio.dont_need`),
  },
  {
    name: 'do_not_understand_product',
    label: toI18n(`${I18N_PREFIX}.tell_us_why.radio.didnt_understand`),
  },
  {
    name: 'other',
    label: toI18n(`${I18N_PREFIX}.tell_us_why.radio.other`),
  },
];

export type CancelAddonsReason =
  | ''
  | 'not_enough_value_for_price'
  | 'no_longer_needed'
  | 'do_not_understand_product'
  | 'other';

export interface AddonCancellationSubmission {
  subscriptionId: string | null;
  reason: CancelAddonsReason;
  reasonElaboration: string;
}
